const gmaps = window.google.maps;
export const ZOOM_BREAK = 8;

export class Marker {

  id;
  data;
  marker;
 
  constructor(data, map, callback) {
    this.id = data.id;
    this.data = data;

    this.createMarker(map, callback);
  }

  createMarker (map, callback) {
    const { id, data } = this;
    const position = new gmaps.LatLng(data.geolocation.lat, data.geolocation.lon);

    this.marker = new gmaps.Marker({
      position,
      map,
      tag: id,
    });
    this.setMarkerIcon();

    if (typeof callback === 'function') {
      this.marker.addListener('click', () => callback(data));
    }

    this.zoomListener = gmaps.event.addListener(map, 'idle', () => this.setMarkerIcon());
  }

  clear ()  {
    gmaps.event.removeListener(this.zoomListener);
    this.marker.setMap(null);
  }

  setMarkerIcon ()  {
    const zoom = this.marker.getMap().getZoom();
    const size = this.getIconSize();
    const scale = zoom < ZOOM_BREAK ? (zoom / ZOOM_BREAK) * size : size;

    const iconName = this.getIconName();
    if(iconName) {
      const icon = {
        url: require(`@/assets/markers/${iconName}.png`),
        size: new gmaps.Size(size, size),
        scaledSize: new gmaps.Size(scale, scale),
        origin: new gmaps.Point(0, 0),
        anchor: new gmaps.Point(scale / 2, scale / 2),
      }
      this.marker.setOpacity(this.getIconOpacity(zoom));
      this.marker.setIcon(icon);
    }
  }

  getIconSize ()  {
    return 1;
  }

  getIconName ()  {
    return '';
  }

  getIconOpacity  () {
    return 1;
  }
}
